import styled from 'styled-components'
import Link from 'next/link'

export const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary.dark1}
`
